import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import useVitalStatisticsComparison from './hooks/useVitalStatisticsComparison';

export const VitalStatisticsComparison = () => {
    const { chartConfig } = useVitalStatisticsComparison();

    return (
        <ChartContainer
            title={"Evolução Anual de Estatísticas Vitais"}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={350}
        />
    );
};
